import axios from "axios";

export default {
  namespaced: true,
  state: {
    fixedassets: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    fixedassetsMessage: ''
  },
  mutations: {
    RECEIVED_FIXED_ASSETS(state, payload) {
      state.fixedassets = payload;
      state.isReceiving = false;
    },
    RECEIVING_FIXED_ASSETS(state) {
      state.isReceiving = true;
    },
    RECEIVED_FIXED_ASSET(state, payload) {
      state = Object.assign(state, {
        fixedassets: [...state.fixedassets, payload],
        isReceiving: false,
      })
    },
    RECEIVING_FIXED_ASSET(state) {
      state.isReceiving = true;
    },
    UPDATED_FIXED_ASSET(state, payload) {
      let index = state.fixedassets.findIndex(fixedasset => fixedasset._id === payload._id);
      state = Object.assign(state, {
        fixedassets: state.fixedassets.map((fixedasset, i) => {
          if (i === index) {
            return Object.assign({}, fixedasset, payload);
          }
          return fixedasset;
        }),
        isUpdating: false,
        fixedassetsMessage: 'FixedAssets has been updating!',
      })
    },
    UPDATING_FIXED_ASSET(state) {
      state.isUpdating = true;
    },
    DELETED_FIXED_ASSET(state, payload) {
      let indexToDelete = state.fixedassets.findIndex(fixedasset => fixedasset._id === payload._id);
      let fixedassets = [...state.fixedassets];
      fixedassets.splice(indexToDelete, 1);
      state = Object.assign(state, {
        fixedassets: [...fixedassets],
        isDeleting: false,
        idToDelete: null,
        fixedassetsMessage: 'FixedAsset has been Deleted!',
      });
    },
    DELETING_FIXED_ASSET(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteFixedAssetRequest({dispatch}, payload) {
      dispatch("deletingFixedAsset", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/fixedasset/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteFixedAsset", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async getFixedAssetsRequest({dispatch}) {
      dispatch("receivingFixedAssets");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/fixedassets';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveFixedAssets", res.data);
      })
    },
    async insertFixedAssetRequest({dispatch}, payload) {
      dispatch("receivingFixedAsset");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/fixedasset';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveFixedAsset", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    updateFixedAssetRequest({dispatch}, payload) {
      dispatch("updatingFixedAsset");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/fixedasset/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateFixedAsset", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    receiveFixedAssets({commit}, payload) {
      commit("RECEIVED_FIXED_ASSETS", payload)
    },
    receivingFixedAssets({commit}) {
      commit("RECEIVING_FIXED_ASSETS")
    },
    receiveFixedAsset({commit}, payload) {
      commit("RECEIVED_FIXED_ASSET", payload)
    },
    receivingFixedAsset({commit}) {
      commit("RECEIVING_FIXED_ASSET")
    },
    updateFixedAsset({commit}, payload) {
      commit("UPDATED_FIXED_ASSET", payload)
    },
    updatingFixedAsset({commit}) {
      commit("UPDATING_FIXED_ASSET")
    },
    deleteFixedAsset({commit}, payload) {
      commit("DELETED_FIXED_ASSET", payload)
    },
    deletingFixedAsset({commit}, payload) {
      commit("DELETING_FIXED_ASSET", payload)
    }
  },
};
